import { SxProps, Theme } from '@mui/material/styles';
import { ReservationStatus } from '../types/reservation';

type ReservationStatusValue = ReservationStatus | string | null | undefined;

interface ReservationStatusPalette {
  backgroundColor: string;
  textColor: string;
}

const STATUS_PALETTES: Record<ReservationStatus, ReservationStatusPalette> = {
  [ReservationStatus.PENDING]: {
    backgroundColor: '#facc15',
    textColor: '#1f2937',
  },
  [ReservationStatus.CONFIRMED]: {
    backgroundColor: '#f97316',
    textColor: '#ffffff',
  },
  [ReservationStatus.DECLINED]: {
    backgroundColor: '#b91c1c',
    textColor: '#ffffff',
  },
  [ReservationStatus.IN_PROGRESS]: {
    backgroundColor: '#3b82f6',
    textColor: '#ffffff',
  },
  [ReservationStatus.COMPLETED]: {
    backgroundColor: '#22c55e',
    textColor: '#ffffff',
  },
  [ReservationStatus.CANCELLED]: {
    backgroundColor: '#ef4444',
    textColor: '#ffffff',
  },
  [ReservationStatus.NO_SHOW]: {
    backgroundColor: '#9ca3af',
    textColor: '#ffffff',
  },
};

const DEFAULT_PALETTE = STATUS_PALETTES[ReservationStatus.NO_SHOW];

export const getReservationStatusPalette = (
  status: ReservationStatusValue
): ReservationStatusPalette => {
  switch (status) {
    case ReservationStatus.PENDING:
      return STATUS_PALETTES[ReservationStatus.PENDING];
    case ReservationStatus.CONFIRMED:
      return STATUS_PALETTES[ReservationStatus.CONFIRMED];
    case ReservationStatus.DECLINED:
      return STATUS_PALETTES[ReservationStatus.DECLINED];
    case ReservationStatus.IN_PROGRESS:
      return STATUS_PALETTES[ReservationStatus.IN_PROGRESS];
    case ReservationStatus.COMPLETED:
      return STATUS_PALETTES[ReservationStatus.COMPLETED];
    case ReservationStatus.CANCELLED:
      return STATUS_PALETTES[ReservationStatus.CANCELLED];
    case ReservationStatus.NO_SHOW:
      return STATUS_PALETTES[ReservationStatus.NO_SHOW];
    default:
      return DEFAULT_PALETTE;
  }
};

export const getReservationStatusColor = (status: ReservationStatusValue): string => {
  return getReservationStatusPalette(status).backgroundColor;
};

export const getReservationStatusChipSx = (
  status: ReservationStatusValue
): SxProps<Theme> => {
  const { backgroundColor, textColor } = getReservationStatusPalette(status);

  return {
    bgcolor: backgroundColor,
    color: textColor,
    fontWeight: 600,
    '& .MuiChip-icon': {
      color: 'inherit',
    },
    '& .MuiChip-deleteIcon': {
      color: 'inherit',
    },
  };
};
